// HOW A MOVE HAPPENED — sent with every scan that changes where a part is or who holds it.
//
// HIS INSTRUCTION, 2026-10-09: *"The camera bug showed we can't look back: the request log keeps
// about 21 minutes, and the moves record doesn't say which screen was used or whether it was the
// camera or the gun. So from now on, every move, put-away and tag capture records: which screen it
// came from; camera, scan gun or typed; the exact code that was scanned."*
//
// `meta` is the second argument every `ScanField` hands its screen. The CAMERA is certain (the
// code came out of the camera's own decode callback). Gun vs typed is judged from keystroke speed
// and the server stores it with `input_certain: false`, so it can never be read as proof.
const device = () => (typeof navigator !== "undefined" && navigator.userAgent) || "";

export function prov(screen, meta) {
  const m = meta || {};
  return {
    screen,
    input: m.input || "unknown",
    code: m.code || "",            // EXACTLY what came off the gun / camera / keyboard
    code_used: m.code_used || m.code || "",
    device: device(),
  };
}

// A button press with no scan at all (undo, a row in a list, a confirm).
export function provTap(screen) {
  return { screen, input: "tap", code: "", code_used: "", device: device() };
}
